import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-3" }
const _hoisted_4 = { class: "col-lg-9" }

import BreadCrumb from "@/components/BreadCrumb.vue";
import Sidebar from "@/components/Sidebar.vue";
import Content from "@/components/Content.vue";
import {computed, onMounted, reactive, ref} from "vue";
import {useOpendataStore} from "@/stores/opendata.store";
import {PageRequest} from "@/api/utils/page-request";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const menus = reactive({
  breads: [{
    id: "1",
    title: "ข้อมูลเปิด (OPEN DATA) กรมพัฒนาธุรกิจการค้า",
    href: "/"
  }]
});
const componentOpbject = reactive({
  loading: false
})
const opendataStore = useOpendataStore();

onMounted(async ()=> {
  const opendata = Promise.all([
    opendataStore.getDatasets(),
    opendataStore.getTagSummary(),
    opendataStore.getFormatSummary(),
    opendataStore.getGroupSummary()
  ]);
  await opendata;

  const recentPage = new PageRequest();
  recentPage._limit = 3;
  recentPage._sort = "createdDate:DESC";

  const popularPage = new PageRequest();
  popularPage._limit = 3;
  popularPage._sort = "totalViews:DESC";

  await opendataStore.getRecentPopular("all", recentPage, popularPage);
});

const filteredValue = ref<string | null | undefined>(null);
const filteredType = ref<string | null | undefined>(null);

const onFilterClick = (selectedValue: string, type: string) => {
  componentOpbject.loading = true;

  setTimeout(() => {
    filteredValue.value = selectedValue;
    filteredType.value = type;

    componentOpbject.loading = false;
  }, 1000);
}

const datasetFiltered = computed(() => {
  if(!filteredValue.value) {
    return opendataStore.datasets;
  } else {
    if(filteredType.value === "tag") {
      return opendataStore.datasets.filter(dataset => dataset?.otagDtos.some(tag => tag?.tagId?.toString() === filteredValue.value));
    } else if(filteredType.value === "format") {
      return opendataStore.datasets.filter(dataset => dataset?.dataFormat === filteredValue.value);
    } else if(filteredType.value === "group") {
      return opendataStore.datasets.filter(dataset => dataset?.gid === filteredValue.value);
    } else if(filteredType.value === "search") {
      return opendataStore.datasets.filter(dataset => (dataset?.title + dataset?.note)?.includes(filteredValue.value.toString()));
    } else {
      return opendataStore.datasets;
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      menus: menus.breads
    }, null, 8, ["menus"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Sidebar, {
            groupSumms: _unref(opendataStore).groupSumm,
            tags: _unref(opendataStore).tags,
            formats: _unref(opendataStore).formats,
            recents: _unref(opendataStore).recents,
            populars: _unref(opendataStore).populars,
            onFilterClick: onFilterClick
          }, null, 8, ["groupSumms", "tags", "formats", "recents", "populars"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createVNode(Content, { datasets: _unref(datasetFiltered) }, null, 8, ["datasets"]), [
            [_directive_loading, componentOpbject.loading]
          ])
        ])
      ])
    ])
  ], 64))
}
}

})